import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <div className="smkg-logo">
      <Link to="/">
        <img src={'/SMK-GIVING.png'} alt="logo" style={{ width: 100, height: 50 }} />
      </Link>
    </div>
  );
};

export default Logo;
